import { Component } from '@angular/core';
import {TeamServiceProvider} from "../../providers/team-service/team-service";

@Component({
  selector: 'powered-by',
  templateUrl: 'powered-by.html'
})
export class PoweredByComponent {

  constructor(private teamProvider: TeamServiceProvider) {
  }

}



// WEBPACK FOOTER //
// ./src/components/powered-by/powered-by.ts